import { render, staticRenderFns } from "./index.vue?vue&type=template&id=61dd6840&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=61dd6840&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dd6840",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61dd6840')) {
      api.createRecord('61dd6840', component.options)
    } else {
      api.reload('61dd6840', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=61dd6840&scoped=true", function () {
      api.rerender('61dd6840', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/channel/EDI/index.vue"
export default component.exports